(() => {
  'use strict';

  if (window.__treedixPdpSummaryInitialized) return;
  window.__treedixPdpSummaryInitialized = true;

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-pdp-key-toggle]');
    if (!toggle) return;

    const panel = toggle.closest('[data-pdp-key-features]');
    if (!panel) return;

    const expanded = panel.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? (toggle.dataset.lessText || 'Show less') : `${toggle.dataset.moreText || 'View all'} →`;
  });
})();
